import { Resources } from 'constants/resources';

import cloneDeepWith from 'lodash/cloneDeepWith';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import isPlainObject from 'lodash/isPlainObject';
import { convertReactAdminIdToHydraId } from 'utils/convertReactAdminIdToHydraId';

export const prepareGatewayRuleFormData = <T>(data: T): T =>
  cloneDeepWith(data, (value, key) => {
    if (key === 'comparisonOperator' && isPlainObject(value) && has(value, 'id')) {
      return convertReactAdminIdToHydraId(value.id, Resources.ComparisonOperators);
    }

    if (key === 'conditionGroup' && isEmpty(value)) {
      return null;
    }

    return undefined;
  });
